module.exports = __webpack_public_path__ + "img/logo2.e1d89506.png";